<footer>
  <div class="container footer-main">
    <a
      class="footer-logo"
      [routerLink]="basePath"
    >
      <img
        [src]="agencyService.agency.logo.url ? agencyService.agency.logo.url : '/assets/icons/logo_footer.svg'"
        [alt]="agencyService.agency.name"
        loading="lazy"
      >
    </a>

    <address class="footer-contact">
      <div class="footer-contact-group">
        <a
          class="footer-item"
          [href]="'tel:' + agencyService.agency.phone"
          appGtagEvent
          eventCategory="contact"
          eventAction="click"
          eventLabel="phone_click"
          appFbqEvent="Contact"
          [customData]="{content_name: 'phone_click', content_category: 'click'}"
        >
          <img
            class="footer-item-icon"
            src="/assets/icons/contact/phone.svg"
            alt=""
          >
          <span class="footer-item-body">
            <span class="footer-item-label">Telefon</span>
            <span class="footer-item-value">{{ agencyService.agency.phone | beautify }}</span>
          </span>
        </a>

        <a
          class="footer-item"
          [href]="'mailto:' + agencyService.agency.email"
          appGtagEvent
          eventCategory="contact"
          eventAction="click"
          eventLabel="email_click"
          appFbqEvent="Contact"
          [customData]="{content_name: 'email_click', content_category: 'click'}"
        >
          <img
            class="footer-item-icon"
            src="/assets/icons/contact/email.svg"
            alt=""
          >
          <span class="footer-item-body">
            <span class="footer-item-label">E-mail</span>
            <span class="footer-item-value">{{ agencyService.agency.email }}</span>
          </span>
        </a>
      </div>

      <a
        class="footer-item"
        [href]="'https://maps.google.com?daddr='
        + agencyService.agency.latitude + ','
        + agencyService.agency.longitude + '&amp;ll='"
        target="_blank"
        rel="noopener noreferrer"
        appGtagEvent
        eventCategory="contact"
        eventAction="click"
        eventLabel="maps_click"
        appFbqEvent="Contact"
        [customData]="{content_name: 'maps_click', content_category: 'click'}"
      >
        <img
          class="footer-item-icon"
          src="/assets/icons/contact/location.svg"
          alt=""
        >
        <span class="footer-item-body">
          <span class="footer-item-label">Adresa</span>
          <span class="footer-item-value">{{ agencyService.agency.address }}</span>
        </span>
      </a>
    </address>

    <div class="footer-aside">
      <div class="footer-certs">
        <img
          src="/assets/icons/iso.webp"
          alt="ISO 9001"
          loading="lazy"
        >
        <img
          src="/assets/icons/cert.png"
          alt="Certificat IQNet"
          loading="lazy"
        >
      </div>

      <a
        class="footer-credit"
        href="https://vaunt.ro/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span class="footer-item-label">Website dezvoltat de</span>
        <img
          src="/assets/icons/vaunt_logo.svg"
          alt="logo vaunt"
          class="logo-vaunt"
        >
      </a>
    </div>
  </div>

  <div class="container footer-legal">
    <div class="footer-legal-copy">
      <p class="footer-disclaimer">
        Toate materialele și randarile au exclusiv scop de prezentare, fără a crea obligații sau răspunderi legale sau contractuale în sarcina dezvoltatorului sau a clientului. Dezvoltatorul își rezervă dreptul de a modifica conținutul și structura prezentării în orice moment.
      </p>
      <p class="footer-copyright">
        © {{ date.getFullYear() }} HOME STORE INVESTMENT S.R.L.
        <span class="footer-sep">·</span>
        <a [routerLink]="[basePath, 'termeni-si-conditii']">
          Termeni și condiții
        </a>
      </p>
    </div>

    <div class="footer-anpc">
      <a
        href="https://anpc.ro/ce-este-sal/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/assets/images/anpcimg1.png" alt="Soluționarea Alternativă a Litigiilor">
      </a>
      <a
        href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/assets/images/anpcimg2.png" alt="Soluționarea Online a Litigiilor">
      </a>
    </div>
  </div>
</footer>



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.html